// extracted by mini-css-extract-plugin
export var aboveInput = "_hd-0";
export var actionButton = "_hd-5";
export var actionButtonContainer = "_hd-1";
export var actionIcon = "_hd-6";
export var aiInfoContainer = "_hd-2";
export var attachmentWrapper = "_hd-7";
export var bold = "_hd-3";
export var checkIcon = "_hd-8";
export var clickingRecipientBar = "_hd-11";
export var commentThreadSwitch = "_hd-a";
export var draftImage = "_hd-b";
export var draftImageContainer = "_hd-c";
export var draftImages = "_hd-e";
export var editButton = "_hd-g";
export var editor = "_hd-f";
export var editorContainer = "_hd-y";
export var editorErrorTooltipWrapper = "_hd-9";
export var headerDivider = "_hd-h";
export var icon = "_hd-i";
export var info = "_hd-j";
export var internal = "_hd-n";
export var internalDivider = "_hd-k";
export var internalMessage = "_hd-l";
export var messageInputCard = "_hd-m";
export var messageInputForm = "_hd-o";
export var messageInputFormInternal = "_hd-p";
export var options = "_hd-q";
export var publicMessageCustomer = "_hd-s";
export var publicMessageMerchant = "_hd-r";
export var removeImageButton = "_hd-d";
export var replyButtons = "_hd-t";
export var showSignatureButton = "_hd-u";
export var spinner = "_hd-v";
export var verticalButtonDivider = "_hd-4";
export var visibilitySelector = "_hd-w";
export var warning = "_hd-x";
export var wrappingText = "_hd-z";
export var writingInternalNoteTopBorder = "_hd-10";